export const setCurrency = (state, param) => {
  state.currency = param
}



// WEBPACK FOOTER //
// ./src/store/modules/properties/mutations.js